import { baseApi } from '../baseApi';

export interface Plan {
  id: string;
  title: string;
  description?: string;
  type: string;
  price: number;
  durationDays: number;
  academicYearId: string;
  subjectId?: string;
  chapterId?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  academicYear?: any;
  subject?: any;
  chapter?: any;
  allowedSubjectIds?: string[];
  notesLimit?: number;
  videosLimit?: number;
  unlimitedNotes?: boolean;
  unlimitedVideos?: boolean;
  allowTests?: boolean;
}

export const planApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlans: builder.query<{ success: boolean; data: Plan[] }, any>({
      query: (params) => ({
        url: '/api/plans',
        params: params || undefined,
      }),
      providesTags: ['Plan' as any], // add tag if not present in baseApi
    }),
    createPlan: builder.mutation<{ success: boolean; data: Plan }, Partial<Plan>>({
      query: (body) => ({
        url: '/api/plans',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Plan' as any],
    }),
    updatePlan: builder.mutation<{ success: boolean; data: Plan }, { id: string; body: Partial<Plan> }>({
      query: ({ id, body }) => ({
        url: `/api/plans/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Plan' as any],
    }),
    deletePlan: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/plans/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Plan' as any],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPlansQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
  useDeletePlanMutation,
} = planApi;
